//
//
//
//

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  }
}
